<div class="pdf-table-preview">
  <table *ngIf="hasData()">
    <thead *ngIf="showHeader">
      <tr [style.fontSize.px]="headerFontSize" [style.fontWeight]="headerFontWeight">
        <th *ngFor="let column of columns"
            [style.width.px]="column.width"
            [style.textAlign]="column.alignment">
          {{ column.headerText }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of tableData" [style.fontSize.px]="rowFontSize">
        <td *ngFor="let column of columns" [style.textAlign]="column.alignment">
          {{ getCellValue(row, column) }}
        </td>
      </tr>
      <tr *ngIf="tableData.length === 0" [style.fontSize.px]="rowFontSize">
        <td [attr.colspan]="columns.length" class="no-data">
          [No data loaded]
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="!hasData()" class="table-placeholder">
    <mat-icon>table_chart</mat-icon>
    <span>PDF Table</span>
    <span class="hint">Configure columns</span>
  </div>
</div>
